module.exports = __webpack_public_path__ + "static/img/shuqitui-mini-program-qr.7a95d5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/shuqitui-mini-program-qr.png
// module id = iLRU
// module chunks = 6